import Branch, { BranchEvent } from 'react-native-branch';

// Branch has a default and named export, add `BranchEvent` to the default export so it looks
// similar.
Branch.BranchEvent = BranchEvent;

export default Branch;
